import {Subscription} from "rxjs";
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {appRoutes} from "@numizmat/constants";
import {AdType} from "@numizmat/enumerations";
import {AlertService} from "@numizmat/services/common";
import {ImageComponent, UserRatingComponent} from "@numizmat/components";
import {PublicAdDetailResponse} from "@numizmat/services-models/core";
import {AdDetailStateService} from "@numizmat/services/core/ad-detail/ad-detail-state.service";
import {environment} from "@numizmat/environments";

@Component({
  selector: 'nz-seller-panel',
  standalone: true,
  imports: [
    UserRatingComponent,
    RouterLink,
    DatePipe,
    ImageComponent
  ],
  templateUrl: './seller-panel.component.html',
  styleUrl: './seller-panel.component.scss'
})
export class SellerPanelComponent implements OnInit, OnDestroy {
  private alertService: AlertService = inject(AlertService);
  private adDetailStateService: AdDetailStateService = inject(AdDetailStateService);

  private subs: Subscription = new Subscription();

  protected sellerProfileImageUrl?: string;
  protected adDetails!: PublicAdDetailResponse;

  protected readonly AdType = AdType;
  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getAdDetails();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected showUserRatingInfo(): void {
    this.alertService.showUserRatingInfo();
  }

  private getAdDetails() {
    const subscription: Subscription = this.adDetailStateService.getPublicAdDetails().subscribe({
      next: (adDetails: PublicAdDetailResponse | undefined) => {
        if (!!adDetails) {
          this.adDetails = adDetails;
          if (!!this.adDetails.sellerProfileImageId) {
            this.sellerProfileImageUrl = `${environment.apiImageUserProfileUrl}/${this.adDetails.sellerId}/${this.adDetails.sellerProfileImageId}`;
          } else {
            this.sellerProfileImageUrl = undefined;
          }
        }
      }
    });
    this.subs.add(subscription);
  }
}
